import { adminHttpClient } from '../../commons/adminHttpClient'

export type UpdatePerksExpenseRequest = {
  expenseId: number
  requestAmount: number
  purchaseDate: Date
  serviceProvider: string
  description: string
  attachments: SaveAttachmentRequest[]
}

type SaveAttachmentRequest = {
  id?: string
  filename: string
  title: string
  reuseInOtherExpenses: boolean
}

const updatePerksExpense = (update: UpdatePerksExpenseRequest): Promise<UpdatePerksExpenseRequest> => {
  return adminHttpClient.post(`/EEDashboard/Perks/UpdateExpense`, update)
}

export default updatePerksExpense
